// Callback function for when component loads. Called dynamically by callback in components.js
function loadProgressCircles() {
  $(".progress-circle-js").each(function () {
    let value = $(this).attr('data-value');
    let left = $(this).find('.progress-left .progress-bar');
    let right = $(this).find('.progress-right .progress-bar');

    if (value > 0) {
      if (value <= 50) {
        right.css('transform', 'rotate(' + percentageToDegrees(value) + 'deg)');
      } else {
        right.css('transform', 'rotate(180deg)');
        left.css('transform', 'rotate(' + percentageToDegrees(value - 50) + 'deg)');
      }
    }

    $(this).removeClass('progress-circle-js')
  });
}

function percentageToDegrees(percentage) {
  return percentage / 100 * 360;
}

window.loadProgressCircles = loadProgressCircles;
